export default "__VITE_ASSET__k4WMhlN4__"